import useTheme from 'branding/theme';
const useColorOverrides = ({ disabled, isHovered, isChecked }) => {
    const { colors } = useTheme();
    const backgroundColor = disabled
        ? colors.neutrals.borderBeta
        : isHovered
            ? colors.brand.primary.alpha
            : isChecked
                ? colors.brand.primary.alpha
                : colors.neutrals.transparent;
    const borderColor = disabled
        ? colors.neutrals.borderBeta
        : isHovered
            ? colors.brand.primary.alpha
            : isChecked
                ? colors.brand.primary.alpha
                : colors.neutrals.borderAlpha;
    return { backgroundColor, borderColor };
};
export default useColorOverrides;
//# sourceMappingURL=useColorOverrides.js.map